var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CityModal, {
    attrs: {
      value: _setup.isDialogOpened,
      "is-back": "",
      "selected-city": _setup.filtersStore.unsavedFilters.city,
    },
    on: {
      "city:selected": _setup.onClickCity,
      "city:reset": _setup.onReset,
      input: _setup.handleCloseCityModal,
    },
    scopedSlots: _vm._u([
      {
        key: "footer",
        fn: function () {
          return [
            _c(_setup.BtnShowDoctors, {
              staticClass: "pa-2 elevation-8",
              attrs: { active: _setup.isDialogOpened },
              on: {
                "click:submit": _setup.applySelectedCity,
                "click:close": _setup.closeDialog,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }